module.exports = __webpack_public_path__ + "img/cortex.26bd3506.jpg";